import {
    IQueryContext,
    QueryContextSettingID,
    IQueryContextDatasourceColumn,
} from '../services/query-context/models/IQueryContext';
import { Factory } from './Factory';
import { IFactory, ICreatedInstanceId } from './IFactory';
import { DatasourceColumnId } from './datasource-sql-map/datasource';

export type DashboardItemComponentType =
    | 'AlertDataTextDashboardItem'
    | 'CategoryFilterDashboardItem'
    | 'DateRangeFilterDashboardItem'
    | 'SegmentsFilterDashboardItem'
    | 'StringInputFilterDashboardItem'
    | 'DataTextDashboardItem'
    | 'RevenueSettingsDashboardItem'
    | 'EchartsDashboardItemComponent'
    | 'TableDashboardItemComponent';
// export interface IGenericChartDataLoaderResult extends IDataLoaderResult {// Omit<IDataLoaderResult, 'data'>  {
//   data: {
//     /** Generic option object for generic charts */
//     chartOption?: any;
//   };
// }
interface IDatasourceColumn {
    datasourceColumn: IQueryContextDatasourceColumn;
}

export interface IDatasourceColumnId {
    datasourceColumnId: DatasourceColumnId;
}

export interface IDatasourceColumnLabel {
    datasourceColumnLabel: string;
}

export interface IComponentClass {
    componentClass: DashboardItemComponentType;
}
export type TitleBar = {
    title: string;
    subtitle?: string;
    titleTooltip?: string;
};
export interface ITitleBar {
    titleBar: TitleBar;
}

/**
 * An interface representing object which is displayed on dashboard
 */
export interface IDashboardItem {
    /** id of current DashboardItem instance */
    instanceId: string;
    component: DashboardItemComponentType;
    /** additional configuration */
    dashboardItem?: any;
    composeData: (rawData: any, context?: IQueryContext) => any;
}

// TODO flatten
export interface ISettingDashboardItem {
    options: {
        id: QueryContextSettingID;
        viewtype: 'singleSelect' | 'multiSelect' | 'checkbox' | 'toggle';
        displayName: string;
        /** Current value */
        value?: any;
        /** Possible values */
        selectOptions?: any;
    };
}

export interface IDatasourceColumnDashboardItem
    extends IDashboardItem,
        IDatasourceColumn,
        IDatasourceColumnId,
        Partial<IDatasourceColumnLabel> {}

export interface IDashboardItemFactoryOptions extends ICreatedInstanceId {}

export interface IDatasourceColumnDashboardItemFactoryOptions
    extends ICreatedInstanceId,
        IDatasourceColumnId {}

export interface IDashboardItemFactory
    extends IFactory<IDashboardItem>,
        IComponentClass {}

export abstract class DashboardItemFactory<
        TInstance extends IDashboardItem,
        TOptions extends IDashboardItemFactoryOptions
    >
    extends Factory<TInstance, TOptions>
    implements IDashboardItemFactory
{
    abstract COMPONENT_CLASS: DashboardItemComponentType;

    public get componentClass(): DashboardItemComponentType {
        return this.COMPONENT_CLASS;
    }
}
